<template>
<div class="main list-view no-subhead">

	<div class="filters">

		<div v-if="clientFFLNumbers.length > 0">
			<div class="title">FFL Number...</div>
			<select v-model="filters.client_ffl_number_id" @change="fetchData()">
				<option v-for="(clientFFLNumber, index) in clientFFLNumbers" :key="index" :value="clientFFLNumber.client_ffl_number_id">{{ clientFFLNumber.ffl_number }}</option>
			</select>
			<div class="divider"></div>
		</div>

		<div class="detail-stats">
			<h2>NOTE</h2>
			<p>These are your log book definitions.</p>
			<p>You can edit or remove any log book definition as long as no records have been added to it.</p>
			<p>And you can add new log book definitions to meet your FFL License needs.</p>
		</div>
	</div>

	<div class="detail">
		<div class="detail-form">

			<div class="logbook-panes">
				<div class="logbook-pane" v-for="(logBook, index) in logBooks">
					<label>Code</label>
					<input type="text" v-model="logBook.ffl_log_book_code" :disabled="logBook.entry_count > 0 || addingNew">
					<label>Description</label>
					<input type="text" v-model="logBook.description" :disabled="logBook.entry_count > 0 || addingNew">
					<label>Starting Sequence</label>
					<input type="text" v-model="logBook.starting_sequence_number" :disabled="logBook.entry_count > 0 || addingNew">

					<div class="remove-button" @click="confirmRemove = index" v-if="logBook.entry_count == 0 && !addingNew"><i class="fas fa-times"></i></div>
					<div v-if="confirmRemove == index" class="confirm-dialog">
						<span>Confirm Remove (cannot be undone)</span>
						<div class="button cancel" @click="confirmRemove = null">Cancel</div>
						<div class="button delete" @click="removeLogBook(index)">Remove</div>
					</div>
				</div>
				<div v-if="addingNew" class="logbook-pane">
					<label>Code</label>
					<input type="text" v-model="newLogbook.ffl_log_book_code">
					<label>Description</label>
					<input type="text" v-model="newLogbook.description">
					<label>Starting Sequence</label>
					<input type="text" v-model="newLogbook.starting_sequence_number">
				</div>
			</div>

			<div class="controls">
				<div class="button neutral spaced" @click="addingNew = !addingNew">{{ addingNew ? 'Cancel ' : '' }}Add Log Book</div>
				<div :class="['button', saveDisabled ? 'disabled' : 'primary', 'spaced']" @click="saveLogBooks()">Save Log Books</div>
			</div>
			<div v-if="message || error" :class="['center', { 'message': message, 'error': error }]">
				{{ message || error }}
			</div>

		</div> <!-- class="detail-form" -->

	</div>

	<loading v-if="loading && logBooks.length < 1"></loading>

	<help-popup :helpLink="{184:'Logbook Definitions'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: '',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			logBooks: [],
			logBooksCopy: [],
			clientFFLNumbers: [],
			loading: false,
			addingNew: false,
			newLogbook: {
				ffl_log_book_code: '',
				description: '',
				starting_sequence_number: ''
			},
			filters: {
				client_ffl_number_id: null
			},
			confirmRemove: null,
			message: null,
			error: null
		}
	},
	created() {
		this.fetchData()
	},
	computed: {
		saveDisabled() {
			if (this.logBooks.length == 0 && !this.addingNew) return true
			if (this.confirmRemove != null) return true
			if (this.addingNew && (!this.newLogbook.ffl_log_book_code || !this.newLogbook.description || !this.newLogbook.starting_sequence_number) ) {
				return true
			}
			var disabled = !this.addingNew
			this.logBooks.forEach((logBook) => {
				if (logBook.entry_count == 0) {
					disabled = false
				}
			})
			return disabled
		}
	},
	methods: {
		fetchData() {
			this.loading = true
			this.apiCall({ destination: 'get_log_books', data: { get_count: 1, client_ffl_number_id: this.filters.client_ffl_number_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.logBooks = obj.logbooks
					this.clientFFLNumbers = obj.client_ffl_numbers
					if (!this.filters.client_ffl_number_id) {
						this.filters.client_ffl_number_id = this.clientFFLNumbers[0].client_ffl_number_id
					}
					this.newLogbook.client_ffl_number_id = this.filters.client_ffl_number_id
				}
			}).catch(err => {
				this.loading = false
				console.log(err)
			})
		},
		cancelAdd() {
			this.newLogbook = {
				ffl_log_book_code: '',
				description: '',
				starting_sequence_number: ''
			}
			this.addingNew = false
		},
		saveLogBooks() {
			if (this.loading || this.saveDisabled) return
			this.loading = true
			var logbooks = this.logBooks
			if (this.addingNew) {
				logbooks.push(this.newLogbook)
			}
			this.apiCall({ destination: 'save_log_book', data: { logbooks: logbooks }}).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.cancelAdd()
					this.fetchData()
					this.message = obj.message
					setTimeout(() => {
						this.message = null
					}, 2000)
				} else {
					this.error = obj.message
				}
			}).catch(err => {
				this.loading = false
				console.log(err)
			})
		},
		removeLogBook(index) {
			var ffl_log_book_id = this.logBooks[index].ffl_log_book_id
			this.apiCall({ destination: 'remove_log_book', data: { ffl_log_book_id: ffl_log_book_id }}).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.confirmRemove = null
					this.fetchData()
					this.message = obj.message
				} else {
					this.error = obj.message
				}
			}).catch(err => {
				this.loading = false
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
$error: #fc4a1a;

.loading {
	font-size: 5em;
    align-items: center;
    justify-items: center;
    display: grid;

    &.show {
	    display: grid !important;
    }
}
.logbook-panes {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2em;
	min-height: 200px;
    @media screen and (min-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
    }
}
.logbook-pane {
	font-size: 0.85em;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 0.5rem;
    padding: 1rem;
    border: 1px solid #ccc;
    color: #282c2e;
    letter-spacing: 1px;
    align-items: center;
    position: relative;

    label {
    	justify-self: right
    }
}
.logbook-add-pane {
	display: grid;
    grid-template-rows: 2fr 1fr;
    grid-gap: 1em;

    @media screen and (min-width: 768px) {
    	grid-template-rows: 1fr;
    	grid-template-columns: 1fr 1fr;
	    grid-gap: 2em;
	    grid-column: span 2;
    }
}
.pane-controls {
    justify-self: center;

    .button {
    	min-width: 145px; display: inline-block; font-size: 0.7em;
    }

    @media screen and (min-width: 768px) {
    	justify-self: left;
    	.button {
    		display: block;
    		margin-bottom: 1em;
    	}
    }
}
.remove-button {
    position: absolute;
    left: 0;
    top: 0;
	font-size: 1.5em;
    color: $error;
    border: $error solid;
    border-width: 0 1px 1px 0;
    padding: 4px 3px 3px 4px;
    cursor: pointer;

    &:hover {
    	background-color: $error;
    	color: white;
    }
}
.confirm-dialog {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    padding: 4em 2em;
    text-align: center;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 1em;
    span {
	    margin-bottom: 3em;
	    display: inline-block;
		grid-column: 1 / 3;
	}
    .button {
    	display: inline-block;
		height: 3em;
    }
}
.add-button {
    border: none;
    grid-template-columns: 1fr;
    justify-items: center;

    .button {
    	font-size: 2em;
	    min-height: 3em;
	    min-width: 3em;
    }
}
.controls {
    text-align: center;
    margin-top: 2rem;
}
.info-box {
	display: grid;
	grid-auto-flow: column;
	grid-column-gap: 1em;
	width: fit-content;
	background-color: #d70101;
	color: white;
	padding: 1em;
}
</style>
